export default __webpack_public_path__ + "2720fd2d3940e0ea3bc2cd17f2a68f77.svg";